import { atom } from 'recoil';

import { PrivatePensionSelectedWithCustomerInfoProps } from './types';

export const customerDetailsEmail = atom<string>({
  key: 'customerDetailsEmail',
  default: '',
});

export const privatePensionSelectedWithCustomerInfo =
  atom<PrivatePensionSelectedWithCustomerInfoProps>({
    key: 'privatePensionSelectedWithCustomerInfo',
    default: undefined,
  });

export const beneficiariesSubmitLoadingState = atom<boolean>({
  key: 'beneficiariesSubmitLoadingState',
  default: false,
});
